export default {
  props: {
    roomId: { required: false },
    profileId: { required: false },
  },
  data() {
    return {
      open: false,
      gifts: [],
    };
  },
  watch: {},
  methods: {
    send(giftId) {
      window.axios
        .post(this.roomId ? zRoute('ajax.chat2.rooms.gifts.store', this.roomId) : zRoute('ajax.chat2.profiles.gifts.store', this.profileId), {
          gift_id: giftId,
        })
        .then(response => {
          this.emitMessage(response.data.data);
          this.emitHide();
        });
    },
    emitMessage(message) {
      this.$emit('message', message);
    },
    emitHide() {
      this.$emit('hide');
    },
    refresh() {
      window.axios
        .get(zRoute('ajax.chat2.gifts.index'))
        .then(response => {
          this.gifts = response.data.data;
        });
    }
  },
  mounted() {
    axios
      .get(zRoute('ajax.chat2.gifts.index'))
      .then(response => {
        this.gifts = response.data.data;
      });
  }
};
